import * as React from 'react'
import { Grid } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import styles from 'components/Shared/Header/Header.module.scss'

type Props = {
  title: string
  subTitle?: string
}

const Header = (props: Props) => {
  const { title, subTitle } = props

  return (
    <Grid item xs={12} md={12}>
      <Box
        className={styles.headerBlock}
        sx={{
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          margin: 0,
        }}
      >
        <Typography variant="h4" className={styles.header}>
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="body2" className="ml-2">
            {subTitle}
          </Typography>
        )}
      </Box>
    </Grid>
  )
}

export default Header
